interface ImageTagProps {
  label?: string;
}

const ImageTag: React.FC<ImageTagProps> = ({ label }) => {
  if (!label) return null;

  return <div className="image-tag">{label}</div>;
};

ImageTag.displayName = 'ImageTag';

export default ImageTag;
